import React from 'react';
import './body-desktop.css'
const BodyDesktop = ({value, styleClass}) => {
    return (
        <>
            <p  className={styleClass}>{value}</p>
        </>
    );
}

export default BodyDesktop;
